import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Paper, Box, Grid } from '@material-ui/core';

import { useStyles } from './styles';

import FreeKmsFeature from './components/FreeKmsFeature';
import InsuranceFeature from './components/InsuranceFeature';
import UnlimitedKmFeature from './components/UnlimitedKmFeature';
import DriverFeature from './components/DriverFeature';
import { useIsDesktop } from 'components/utilities';
import { DesktopCarInfo } from './components/DesktopCarInfo';
import { MobileCarInfo } from './components/MobileCarInfo';

const CarCard = ({ car }) => {
	const classes = useStyles();
	const isDesktop = useIsDesktop();

	return (
		<Link to={`/car/${car.id}`} className={classes.root}>
			<Paper className={classes.wrapper}>
				<Box
					p={isDesktop ? 3 : 2}
					textAlign="left"
					height="100%"
					display="flex"
					flexDirection="column"
				>
					{isDesktop ? (
						<DesktopCarInfo car={car} />
					) : (
						<MobileCarInfo car={car} />
					)}

					<Box pt={3} mt="auto">
						<Grid container spacing={1} wrap="nowrap">
							{car.office.driver && (
								<Grid item xs={12}>
									<DriverFeature />
								</Grid>
							)}
							{car.insurance && (
								<Grid item xs={12}>
									<InsuranceFeature />
								</Grid>
							)}
							{car.unlimited_km && (
								<Grid item xs={12}>
									<UnlimitedKmFeature />
								</Grid>
							)}
							{!car.unlimited_km && (
								<Grid item xs={12}>
									<FreeKmsFeature freeKms={car.free_kms} />
								</Grid>
							)}
						</Grid>
					</Box>
				</Box>
			</Paper>
		</Link>
	);
};

CarCard.propTypes = {
	car: PropTypes.object,
};

export default CarCard;
